// import moment from 'moment';
import moment from  'moment-timezone';





export function formatAsDateTimeZone(date, timezones){

 
  }

export const tConvert = (time) => {
  //this function is using 24 hours format to 12 hours format
  try {
    if (time) {
      // Check correct time format and split into components
      time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      if (time.length > 1) { // If time format correct
        time = time.slice(1);  // Remove full string match value
        time[5] = +time[0] < 12 ? ' AM' : ' PM'; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
        time[3] = ''; //remove second
      }
      return time.join(''); // return adjusted time or original string
    }
    return '';
  } catch (e) {
    console.error(e);
    return ''
  }
};

/** 
 * get start / end time of a service obj
 * depending whether it is started or not respectively
 * 
 * @param service object containing info about a service
 * @returns {string} time with respective start / end prefix
 * 
 */
// export const getServiceTime = service => {
//   try {
//     if (service?.serviceStatus === "CREATED" || service?.serviceStatus === "STARTED") {
//       return " starts at " + formatAsTime(service?.startTime)
//     }

//     if (service?.serviceStatus === "COMPLETE") {
//       return " ends at " + formatAsTime(service?.endTime)
//     }

//     return ""

//   } catch (e) {
//     return ""
//   }
// }

function addMinutes(date, minutes){
  date.setMinutes(date.getMinutes() + minutes);
  return date;
}
export const getServiceTime = (service, range = true) => {
  try {
    // if (service?.serviceStatus === "CREATED" || service?.serviceStatus === "STARTED") {
    //   return " starts at " + formatAsTime(service?.startTime)
    // }

    // if (service?.serviceStatus === "COMPLETE") {
    //   return " ends at " + formatAsTime(service?.endTime)
    // }
    const time_zones = window.default_store_timezone;
    const startTime = service?.offsetStartTime;
     const endTime = service?.offsetEndTime;
   
    const dates = getEndTimeByDuration(service);
    const startTimeStr = formatAsTime(startTime, time_zones);
    const endTimeStr = formatAsTime(dates, time_zones);
    const endDateTime = formatAsTime(endTime,time_zones);
   

    
    
    if(range){
      return `${startTimeStr ? ` ${startTimeStr}` : ' ends at '}${endDateTime ? ` - ${endDateTime}` : ''}`
     }else{
      return `${endDateTime ? `${endDateTime}` : ''}` 
     }
   
  } catch (e) {
    return ""
  }
}

export function formatAsTimeforSlot(date, tz) {
  if (!date) {
    return '';
  }

  try {
    // Parse the input date string as UTC using moment.js
    const utcDate = moment.utc(date);

    // Format the UTC date as local time in the provided timezone
    const localDate = utcDate.clone().tz(tz);

    // Format the local date as desired time format
    return localDate.format('hh:mm A');
  } catch (error) {
    console.error('Error formatting time:', error);
    return ''; // Return empty string in case of error
  }
}

export const getSlotTime = (service, range = true) => {
  

    try {
     
      const time_zones = window.default_store_timezone;
      const startTime = service?.slotStartTime;
      const endTime = service?.slotEndTime;
      // const dates = getEndTimeByDuration(service);
      const startTimeStr = formatAsTimeforSlot(startTime, time_zones);
      const endTimeStr = formatAsTimeforSlot(endTime, time_zones);
      return `${startTimeStr ? ` ${startTimeStr}` : ' ends at '}${endTimeStr ? ` - ${endTimeStr}` : ''}`
      
     
    } catch (e) {
      return ""
    }
   
}





// checks & returns which day has same start & end time
export const getSameTimeWeekName = availabilityDetails => {
  try {
    return availabilityDetails?.find?.(item => item?.checked && item?.availabilityOpenTime && item?.availabilityOpenTime === item?.availabilityCloseTime);
  } catch (e) {
    console.error(e);
    return undefined
  }
}

// /* Month-Day-Year */ formatting
export const 
formatDate = date => {
  try {
    if (!date) {
      return ''
    }

    return moment(date).format('MM-DD-YYYY')
  } catch (e) {
    console.error(e);
    return ''
  }
}
//BKI-1290 related change
export const TestFunction = (userProvidedDate, desiredTimezone) => {
  // const userDateInDesiredTimezone = moment.tz(userProvidedDate, desiredTimezone);
  const userDateInDesiredTimezone = moment.tz(userProvidedDate, 'YYYY-MM-DD', desiredTimezone);
  // Set the time to the beginning of the day (00:00:00)
  const beginningOfDayInDesiredTimezone = userDateInDesiredTimezone.startOf('day');
  // Convert to UTC
  const beginningOfDayInUTC = beginningOfDayInDesiredTimezone.utc();
  // Return the formatted date in ISO format
  return beginningOfDayInUTC.toISOString()

}

// format date and time `MM-DD-YY HH:mm A` (AM / PM), If discard utc is true, the function will assume that the input date is in UTC time and convert it to the local time zone before formatting it. If it is false, the function will format the input date without any time zone conversion.
// eg: 05-10-2022 10:52 AM
export const formatDateAndTime = (date, discardUtc = true) => {
  try {
    if (!date) {
      return ''
    }

    if (discardUtc) {
      return moment.utc(date).format('MM-DD-YYYY hh:mm A')
    }

    return moment(date).format('MM-DD-YYYY hh:mm A')
  } catch (e) {
    console.error(e);
    return ''
  }
}

/**
 * Converts a local date object / timestamp into UTC 
 * @param {Date | String} date date to parse
 * @param {String=} tz timezone to convert (optional)
 * @returns formatted time
 */

//BKI-1290 converting the response to required specific timezone's 'AM, PM  time format .
// export function formatAsTime(date, tz) {
//   if (!date) {
//     return ''
//   }
//   const utcDate = new Date(date);
//   const formatter = new Intl.DateTimeFormat('en-US', {
//     timeZone: tz,
//     hour12: false,
//     year: 'numeric',
//     month: 'numeric',
//     day: 'numeric',
//     hour: 'numeric',
//     minute: 'numeric',
//     second: 'numeric',
//   });
//   const localDate = formatter.format(utcDate);
//   // return toLocal(date).format('hh:mm A')
//     return moment(localDate).format('hh:mm A')

// }
export function formatAsTime(date, tz) {
  if (!date) {
    return '';
  }

  const utcDate = new Date(date);

  // Use moment-timezone to format the date in the specified timezone
  const localDate = moment(utcDate).tz(tz).format('hh:mm A');
  
  return localDate;
}


//BKI-1290 converting the response to required specific timezone's utc time format .
export function formatAsTimeForCalendar(date, tz,time) {
  if (!date) {
    return ''
  }
 
  const utcDate = new Date(date);
  // const formatter = new Intl.DateTimeFormat('en-US', {
  //   timeZone: tz,
  //   hour12: false,
  //   year: 'numeric',
  //   month: 'numeric',
  //   day: 'numeric',
  //   hour: 'numeric',
  //   minute: 'numeric',
  //   second: 'numeric',
  // });
  
  const localDate = moment(utcDate).tz(tz);
  // const localDate = formatter.format(utcDate);
  if(time === true){
    // return localDate;
    // return // If time is needed, return the formatted date and time
    return localDate.format('M/D/YYYY, HH:mm:ss');
  }else{
  // Parse the input date string
const parsedDate = moment(localDate, "M/D/YYYY, HH:mm:ss");

// Format the date in the desired output format
const formattedDate = parsedDate.format('YYYY-MM-DD');
  // return toLocal(date).format('hh:mm A')
    return formattedDate;}

}



export function formatAsDate(date, tz) { //used for converting the date to utc timezone .
  if (!date) {
    return ''
  }
  // const utcDate = new Date(date);
  const originalDate = new Date(date);

const targetTimeZone = window.default_store_timezone; // Replace with the desired time zone
// Create a new Intl.DateTimeFormat object with the target time zone
const formatter = new Intl.DateTimeFormat('en-US', {
  timeZone: targetTimeZone,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
});

const str = formatter.format(originalDate);
// Format the original date in the target time zone
const utcString = formatter.format(new Date(originalDate));
return utcString; 


}
//format a date and time as a string in ISO 8601 format.The function then uses the moment() function to create a moment object that represents the input date in the local time zone. It then uses the format() method to format the moment object into a string with the specified format string.
export function toLocalDateAndTimeString(date) {
  return moment(date)?.format('YYYY-MM-DDTHH:mm:ss')
}
//toISOString() method returns a string in UTC time zone, regardless of the time zone of the original input date. If you need to convert the input date to a string in the local time zone, you can use the moment().format() method with a format string that represents the desired format.
export const toISO = (date, tz) => {
  if (!date) {
    return null
  }

  
  
  // @TODO
  // Library https://momentjs.com/timezone/ is required
  // If a specific tiemzone is passed
  // if (tz) {
  //   // https://stackoverflow.com/a/43113505/11667949
  //   const m = moment.utc(date)
  //   return m.clone().tz(tz)
  // }

  // https://stackoverflow.com/a/28641878/11667949
  return moment(date).toISOString()
}

export const toLocal = (date, tz) => {
  if (!date) {
    return null;
  }

  const m = moment(date)

  // @TODO
  // if an optional timezone is passed
  // if (tz) {
  // See https://momentjs.com/timezone/ 
  //   return moment.tz(date, tz)
  // }

  // just return moment object ( :) )
  // moment(<utc_timestamp>) is enough!
  return m;
}

export function getEndTimeByDuration(appointment) {
  const [value, unit] = appointment?.duration?.split(' ') ?? []; //`duration` field will be in form of `20 minutes` (or hours or days) 
  if (!(value && unit)) {
    const id = appointment?.id ?? appointment?.appointmentId;
    if (id) {
      console.warn(`No duration field found in appointment ${id}`)
    }
    return appointment?.endTime
  }

  return toLocal(appointment.startTime).add(value, unit);
}

export const currentTimeZone=()=>{
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export const retailerTimeZone =()=>{
  return  window.default_store_timezone;
  
}




export const todaysTime = (date)=>{
  return moment(date).format('YYYY-M-D')
}